import React from "react";
import RecentItem from "../recent-summary/parts/RecentItem";
import RecentSummary from "../recent-summary/RecentSummary";
import iconPdf from "../../assets/images/dummy/icon-pdf.png";
import { IconDownload } from "../../icons/Icon";
import { SKITRS_CATEGORY } from "../../constants/categories";

const title = "Faldones recientes";
const badgeColor = "#FFD88D";

const RecentSkirts = ({ skirts, download, downloading }) => {
  return (
    <RecentSummary
      title={title}
      badgeColor={badgeColor}
      noData={!skirts.length}
    >
      {skirts.map((skirt) => (
        <RecentItem
          key={skirt.id}
          icon={iconPdf}
          primaryInfo={skirt.filename}
          secondaryInfo={(skirt.views == 0) ? "Visualizado: No" : `Visualizaciones: ${skirt.views}`}
          controlIcon={<IconDownload color="#33383F" />}
          control={() => download(SKITRS_CATEGORY, skirt.id)}
          loading={downloading === skirt.id}
        />
      ))}
    </RecentSummary>
  );
};

export default RecentSkirts;
